<template>
    <div>
        <el-card class="box-card" shadow="never" style="border:0;">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <div slot="header" style="border-bottom:0;">
                <span style="font-size:20px;">广告管理</span>
            </div>

        <!--工具条-->
        <el-tabs v-loading="loading" element-loading-text="数据加载中...">
            <el-tab-pane label="广告列表">
                <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
                    <el-form :inline="true" :model="topForm" ref="topForm">

                        <el-form-item>
                            <el-button type="primary" class="" @click="add()"><i class="fa fa-plus"></i>&nbsp;新增
                            </el-button>
                        </el-form-item>

                        <el-form-item prop="name" style="margin-left: 2%">
                            <el-input v-model="topForm.name" placeholder="广告名称" ></el-input>
                        </el-form-item>

                        <el-form-item style="margin-left: 2%">
                            <el-button type="primary" class="" @click="searchData()" icon="search" :loading="loading">查询</el-button>
                        </el-form-item>
                        <!--<el-form-item>
                          <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                        </el-form-item>-->

                    </el-form>
                </el-col>

                <!-- 表格分页-->
                <div class="block">
                    <el-table element-loading-text="拼命加载中" ref="table" :data="tableData" border style="width: 100%">
                        <el-table-column prop="imgUrl" label="素材" >
                            <template slot-scope="scope">
                <span v-if=" scope.row.imgUrl != ''">
                  <img :src="fileHost+scope.row.imgUrl" class="avatar" />
                  <a>.jpg</a>
                </span>
                  <span v-else>
                  <video  id="video" class="avatar" :src="fileHost+scope.row.videoUrl" v-if="scope.row.videoUrl.split('.') == 'mp4' ">
                      <a>.mp4</a>
                  </video>
                  <img  class="avatar" v-else="scope.row.videoUrl.split('.') == 'mp3'" src="../../../assets/mp3.png"/>
                  </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="advertiseName" label="广告名称" > </el-table-column>
                        <el-table-column prop="typeName" label="广告类型">  </el-table-column>

                        <el-table-column label="广告位置">
                            <template scope="scope">
                                <div v-if="scope.row.pageType=='index'">首页</div>
                                <div v-if="scope.row.pageType=='indexAudio'">首页音频</div>
                                <div v-if="scope.row.pageType=='listAudio'">商品列表页音频</div>
                                <div v-if="scope.row.pageType=='detailAudio'">商品详情页音频</div>
                                <div v-if="scope.row.pageType=='payAudio'">购买页音频</div>
                                <div v-if="scope.row.pageType=='qrAudio'">扫码购买音频</div>
                                <div v-if="scope.row.pageType=='deliveryAudio'">提货页音频</div>
                                <div v-if="scope.row.pageType=='takeawayAudio'">外卖提货页音频</div>
                                <div v-if="scope.row.pageType=='vendingAudio'">出货中音频</div>
                                <div v-if="scope.row.pageType=='successAudio'">完成页音频</div>
                                <div v-if="scope.row.pageType=='vendoverAudio'">下件取货音频</div>
                                <div v-if="scope.row.pageType=='failAudio'">出货异常页音频</div>
                                <div v-if="scope.row.pageType=='button'">首页双按钮-左</div>
                                <div v-if="scope.row.pageType=='buttonRight'">首页双按钮-右</div>
                                <div v-if="scope.row.pageType=='buttonMiddle'">首页单按钮-居中</div>
                                <div v-if="scope.row.pageType=='excode'">提货页</div>
                                <div v-if="scope.row.pageType=='shipment'">出货页</div>
                                <div v-if="scope.row.pageType=='vend'">完成页</div>
                                <div v-if="scope.row.pageType=='vendFail'">出货异常页</div>
                                <div v-if="scope.row.pageType=='float'">首页悬浮按钮</div>
                                <div v-if="scope.row.pageType=='ThirdUrl'">第三方页面</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fodderSize" label="素材大小">  </el-table-column>

                        <!--<el-table-column prop="videoUrl" label="视频URL" >
                          <template slot-scope="scope">
                            <video id="video" style="width: 50px;height: 50px;" :src="fileHost+scope.row.videoUrl" ></video>
                          </template>
                        </el-table-column>-->
                        <el-table-column prop="updateTime" label="更新日期" :formatter="formatter">  </el-table-column>
                        <el-table-column label="操作" width="255px">
                            <template scope="scope" >
                                <el-button  size="small" type="primary" @click="advertiseEdit(scope.row)" >编辑</el-button>
                                <el-button  size="small"  type="primary" @click="unassignClient(scope.row)" >发布</el-button>
                                <el-button  size="small"  type="danger"  @click="handleDelete(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
                <div class="block">
                    <el-pagination
                            @current-change="handleCurrentChange"
                            @size-chahange="handleSizeChange"
                            :current-page="currentpage"
                            :page-count="pagesCount"
                            :page-sizes="pagesizes"
                            :page-size="pagesize"
                            :total="pagesCount"
                            background
                            layout=" total, prev, pager, next, jumper"
                    >
                    </el-pagination>


                </div>
            </el-tab-pane>
            <el-tab-pane label="发布记录">
                <el-select class="m-1" v-model="branchIndex" placeholder="分部" @change="getPush()">
                    <el-option v-for="(item,index) in branchList" :label="item.branchName" :value="index">{{item.branchName}}</el-option>
                </el-select>
                <!--<el-select class="m-1" clearable v-model="orgId" placeholder="机构" @change="getData()">
                    <el-option v-for="(item,index) in orgList" :label="item.org_name" :value="item.org_id">{{item.org_name}}</el-option>
                </el-select>-->
                <!--<el-input v-model="deviceId" clearable placeholder="设备编号" style="width: auto;"></el-input>-->
                <!-- 表格分页-->
                <div class="block">
                    <el-table element-loading-text="拼命加载中" ref="table" :data="pushData" border style="width: 100%">
                        <el-table-column prop="advertiseName" label="广告名称" > </el-table-column>
                        <el-table-column prop="deviceId" label="设备名称">  </el-table-column>
                        <el-table-column label="广告位置">
                            <template scope="scope">
                                <div v-if="scope.row.pageType=='index'">首页</div>
                                <div v-if="scope.row.pageType=='indexAudio'">首页音频</div>
                                <div v-if="scope.row.pageType=='listAudio'">商品列表页音频</div>
                                <div v-if="scope.row.pageType=='detailAudio'">商品详情页音频</div>
                                <div v-if="scope.row.pageType=='payAudio'">购买页音频</div>
                                <div v-if="scope.row.pageType=='qrAudio'">扫码购买音频</div>
                                <div v-if="scope.row.pageType=='deliveryAudio'">提货页音频</div>
                                <div v-if="scope.row.pageType=='takeawayAudio'">外卖提货页音频</div>
                                <div v-if="scope.row.pageType=='vendingAudio'">出货中音频</div>
                                <div v-if="scope.row.pageType=='successAudio'">完成页音频</div>
                                <div v-if="scope.row.pageType=='vendoverAudio'">下件取货音频</div>
                                <div v-if="scope.row.pageType=='failAudio'">出货异常页音频</div>
                                <div v-if="scope.row.pageType=='button'">首页双按钮-左</div>
                                <div v-if="scope.row.pageType=='buttonRight'">首页双按钮-右</div>
                                <div v-if="scope.row.pageType=='buttonMiddle'">首页单按钮-居中</div>
                                <div v-if="scope.row.pageType=='excode'">提货页</div>
                                <div v-if="scope.row.pageType=='shipment'">出货页</div>
                                <div v-if="scope.row.pageType=='vend'">完成页</div>
                                <div v-if="scope.row.pageType=='vendFail'">出货异常页</div>
                                <div v-if="scope.row.pageType=='float'">首页悬浮按钮</div>
                                <div v-if="scope.row.pageType=='ThirdUrl'">第三方页面</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fodderSize" label="素材大小">  </el-table-column>
                        <el-table-column prop="startTime" label="开始时间" :formatter="formatterstart">  </el-table-column>
                        <el-table-column prop="endTime" label="结束时间" :formatter="formatterend">  </el-table-column>
                        <el-table-column label="操作" width="255px">
                            <template scope="scope" >
                                <el-button  size="small" type="primary"  @click="pushEdit(scope.row)" >编辑</el-button>
                                <el-button  size="small"  type="danger"  @click="pushDelete(scope.row)">结束</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
                <div class="block">
                    <el-pagination
                            @current-change="handleCurrentChange"
                            @size-chahange="handleSizeChange"
                            :current-page="currentpage"
                            :page-count="pushpagesCount"
                            :page-sizes="pagesizes"
                            :page-size="pagesize"
                            :total="pushpagesCount"
                            background
                            layout=" total, prev, pager, next, jumper"
                    >
                    </el-pagination>


                </div>
            </el-tab-pane>
        </el-tabs>
        </el-card>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    export  default{
        name: 'advertiseManager',
        props: {
            caption: {
                type: String,
                default: '广告管理'
            },
            hover: {
                type: Boolean,
                default: false
            },
            striped: {
                type: Boolean,
                default: false
            },
            bordered: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            fixed: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pushpagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                pushData: [], // 分页组件传回的分页后数据
                kioskData: [], // 分页组件传回的分页后数据
                storeData: [], // 分页组件传回的分页后数据
                groupData: [], // 分页组件传回的分页后数据
                /*弹窗选择*/
                dialogFormVisible: false,
                //参数设置
                url: this.adserver+"/advertise/findAdvertiseInfo", // 分页查询请求路径
                pushurl: this.adserver+"/advertise/pushRecord", // 分页查询请求路径
                fileHost: this.fileHost,
                name:'',
                options: [
                ],
                loading:false,
                /*弹窗内容选择*/
                topForm:{
                    name:''
                },
                isorno:false,
                isorginit:'0',
                issecondorginit:'0',
                orglevel:'',
                isSecondable:true,
                isLastable:true,
                branchList:[],
                fusionToken:'',
                branchIndex:'',
                recordToken:''
            }

        },
        created(){
//            this.getKisok();
            this.getBranch();
//            this.getGroup();
//            this.getStore();

        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getData();
            },
            searchData(){
                this.activeNum = 0;
                this.getData()
            },
            getBranch(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.branchList=response.body.Data.branchs;
                            this.fusionToken = response.body.Data.branchs[0].fusionToken;
                            this.branchIndex = 0;
                            this.recordToken = response.body.Data.branchs[0].fusionToken;
                            this.getData();
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            getData(){
                //数据请求
                this.loading = true
                var a = localStorage.getItem('Token');
                var params = {iDisplayStart:this.activeNum,iDisplayLength:this.pagesize,advertiseName:this.topForm.name
                    ,Token: this.fusionToken};
                this.$http.post(this.url,params
                ).then(response => {
                    if (response.status === 200) {
                        if(response.body.code=='500') {
                            this.tableData = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.code=='501'){
                            this.tableData = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else{
                            this.$message.success('数据获取成功！')
                            //this.currentpage = 1
                            this.pagesCount = response.body.total
                            this.tableData = response.body.data
                            this.loading = false;
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.tableData = []
                    }
                },function(response){
                    this.tableData = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
                this.fileSpan();
                this.getPush();
            },
            getPush(){
                //数据请求
                this.loading = true
                this.recordToken = this.branchList[this.branchIndex].fusionToken;
                var pushparams = {iDisplayStart:this.activeNum,iDisplayLength:this.pagesize,Token: this.recordToken};
                this.$http.post(this.pushurl,pushparams
                ).then(response => {
                    if (response.status === 200) {
                        if(response.body.code=='500') {
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.code=='501'){
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else{
                            this.$message.success('数据获取成功！')
                            this.pushpagesCount = response.body.total
                            this.pushData = response.body.data
                            this.loading = false;
                            this.getKisok();
                        }
                    }
                },function(response){
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'

                    });
                })
                this.fileSpan();
            },
            formatter(row, column) {
                var d = new Date(row.updateTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            formatterstart(row, column) {
                var d = new Date(row.startTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            formatterend(row, column) {
                var d = new Date(row.endTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            handleDelete(row) {
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var pam = {advertiseId:row.advertiseId,Token:this.fusionToken}
                    this.$store.dispatch('delAdv',pam).then((data)=>{
                        if(data.code== "200") {
                            this.$message({showClose: true, message: '删除成功', type: 'success'});
                            this.getData();
                        }else if(data.code== "501"){
                            this.$message({showClose: true, message: data.msg, type: 'error'});
                        }else{
                            this.$message({showClose: true,message: data.msg,type: 'error'});
                        }
                    })
                })
            },
            pushDelete(row) {
                this.$confirm('你确定要结束此广告么？结束是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('delPush',row.id).then((data)=>{
                        if(data.code== "200") {
                            this.$message({showClose: true, message: '结束成功', type: 'success'});
                            this.getPush();
                        }else if(data.code== "201"){
                            this.$message({showClose: true, message: "结束失败", type: 'error'});
                        }else{
                            this.$message({showClose: true,message: data.msg,type: 'error'});
                        }
                    })
                })
            },
            add(){
                this.savecookie("button", "AdvertiseAdd");
                this.$router.push( {path:"AdvertiseAdd",query: {go:'button'}})
            },
            unassignClient(row){
                this.savecookie("button", "AdPush");
                this.$router.push( {path:"AdPush",query:{advId:row.advertiseId,acvName:row.advertiseName,go:'button'}})
            },
            advertiseEdit(row){
                this.$http.get(this.adserver+"/advertise/findPushRecordByAdvertiseId?advertiseId="+row.advertiseId+"&Token=123123aa")
                    .then(response => {
                        if (response.body.code === '200') {
                            var nowTime = new Date().getTime();
                            let adlist = response.body.data
                            let idlist = []
                            for (let adIndex = 0; adIndex < adlist.length; adIndex++){
                                let startTime =  new Date(adlist[adIndex].startTime).getTime();

                                let endTime =  new Date(adlist[adIndex].endTime).getTime();
                                console.log(startTime < nowTime);
                                console.log(nowTime < endTime);
                                debugger
                                if ((startTime < nowTime) && (nowTime < endTime))
                                    idlist.push(adlist[adIndex].advertiseId)
                            }
                            if (idlist.includes(row.advertiseId)){
                                this.$message({showClose: true, message: '广告正在进行，无法编辑', type: 'error'});
                            } else {
                                this.savecookie("button", "AdvertiseModify");
                                this.$router.push({path:"AdvertiseModify",query:{data:row,go:'button'}});
                            }
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            pushEdit(row){
                var d = new Date().getTime();
                /*var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                var newDate =  moment(d).format(formatString);*/
                let startTime =  new Date(row.startTime).getTime();
                let endTime =  new Date(row.endTime).getTime();
                if((startTime < d) && (d < endTime)){
                    this.$message({showClose: true, message: '广告正在进行，无法编辑', type: 'error'});
                }else {
                    this.$router.push( {path:"PushModify",query:{Id:row.id,acvName:row.advertiseName,
                        startTime:row.startTime,endTime:row.endTime}});
                }
            },
            /** ----------------发布记录--------------------- **/
            getKisok(){
                var params = {Token: this.recordToken};
                //this.$http.post(this.adserver+"/advertise/api/kioskList",params).then(response => {
                this.$http.post(this.adserver+"/advertise/kioskList",params).then(response => {
                    if (response.status === 200) {
                        if(response.body.Code=='500') {
                            this.kioskData = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.Code=='501'){
                            this.kioskData = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.Code=='200'){
                            this.kioskData = response.body.Data.Kiosks;
                            this.getClientName();
                            this.$message.success('数据获取成功！')
                        }
                    }
                },function(response){
                    this.kioskData = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
//            getStore(){
//                storeGet().then(res => {
//                    if (res.data.Code == "200"){
//                        this.storeData= res.data.Data.Stores;
//                        this.getClientName();
//                    }
//                }).catch(err => {
//                    alert("异常：" + err);
//                })
//            },
//            getGroup(){
//                group().then(res => {
//                    if (res.data.Code == "200") {
//                        this.groupData = res.data.Data.Groups;
//                        this.getClientName();
//                    }
//                }).catch(err => {
//                    alert("异常：" + err);
//                })
//            },
            getClientName(){

                for (var i = 0; i < this.pushData.length; i++){
                    var name = "";
                    /**机器**/
                    for(var j = 0; j < this.kioskData.length; j++){
                        if(this.pushData[i].deviceId == this.kioskData[j].ID){
                            name = this.kioskData[j].Name;
                        }
                    }
                    if(name != ''){
                        this.pushData[i].deviceId = name;
                    }
                }
            },
            /**--------------------------------------end--------------------------------------------------------**/
            fileSpan(){
                this.isorno=false;
            }
            /**--------------------------------------end--------------------------------------------------------**/
        }
    }


</script>



// WEBPACK FOOTER //
// AdvertiseManager.vue?090db743